import "./styles.css";

import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Homepage from "./pages/Homepage.jsx";
import ContactPage from "./pages/Contact.jsx";
import PrivacyPage from "./pages/Privacy.jsx";
import PrivacyPageApp from "./pages/privacy_app.jsx";
import TermsPage from "./pages/Terms.jsx";


export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-black">

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/privacy_app" element={<PrivacyPageApp />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </div>
    </Router>
  );
}
